import { cn } from "../../lib/cn";

/**
 * Indicador de entorno bajo el nombre «PrintFlow», portado de `imprenta`
 * (paridad, ADR 0027). Se configura con dos variables de build de Pages:
 * `VITE_ENV_LABEL` (texto) y `VITE_ENV_COLOR` (red | orange | blue | yellow).
 * En producción van vacías y no se muestra nada.
 */
const ESTILOS: Readonly<Record<string, string>> = {
  red: "bg-red-100 text-red-700 border-red-300",
  orange: "bg-orange-100 text-orange-700 border-orange-300",
  blue: "bg-blue-100 text-blue-700 border-blue-300",
  yellow: "bg-yellow-100 text-yellow-700 border-yellow-300",
};

export function etiquetaEntorno(
  label: string | undefined,
  color: string | undefined,
): { texto: string; clases: string } | null {
  if (!label || !color) return null;
  if (!Object.hasOwn(ESTILOS, color)) return null;
  return { texto: label, clases: ESTILOS[color] as string };
}

const BASE = {
  // Barra mobile y drawer.
  compacta: "text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded border w-fit",
  // Sidebar de escritorio de `imprenta`.
  sidebar: "text-xs font-bold uppercase tracking-wider px-2 py-0.5 rounded border w-fit",
} as const;

export function EtiquetaEntorno({
  label = import.meta.env.VITE_ENV_LABEL,
  color = import.meta.env.VITE_ENV_COLOR,
  variante = "compacta",
}: {
  label?: string;
  color?: string;
  variante?: keyof typeof BASE;
}) {
  const etiqueta = etiquetaEntorno(label, color);
  if (!etiqueta) return null;
  return <span className={cn(BASE[variante], etiqueta.clases)}>{etiqueta.texto}</span>;
}
